let code = 'geoapi';
let codeAPI = 'geoapi';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};